import script from "./AddRole.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRole.vue?vue&type=script&setup=true&lang=js"

import "./AddRole.vue?vue&type=style&index=0&id=b3e71cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3e71cfc"]])

export default __exports__